import data from "../data/tech.json";

const cppQuiz = data.cpp;
const cQuiz = data.c;
const rQuiz = data.r;
const goQuiz = data.go;
const gitQuiz = data.git;
const bashQuiz = data.bash;
const xmlQuiz = data.xml;
const aiQuiz = data.ai;
const githubQuiz = data.github;
const dockerQuiz = data.docker;
const linuxQuiz = data.linux;
const mathQuiz = data.math;
const photoshopQuiz = data.photoshop;
const rustQuiz = data.rust;

export {cppQuiz, cQuiz, rQuiz, goQuiz, gitQuiz, bashQuiz, xmlQuiz, aiQuiz, githubQuiz, dockerQuiz, linuxQuiz,
    mathQuiz, photoshopQuiz,  rustQuiz
};